export default __webpack_public_path__ + "static/media/Donald P. Wagner.4f10e50a.jpg";